import type { LiveRecordType } from './types';

export const PAGE_SIZE = 24;

export const PROCESSING_POLL_INTERVAL_MS = 20_000;

export const ITEMS_PER_ROW = {
  sm: 1,
  lg: 2,
  qhd: 5,
  'qhd-plus': 5,
  default: 4,
  placeholder: 4,
};

/**
 * 子 tab：全部 / Editing / Avatar。「全部」只是展示用的空筛选，不是一种回放归属，
 * 所以请求时不带 live_mode；另外两个的取值直接就是接口的 live_mode。
 */
export const LIVE_RECORD_TABS = ['all', 'editing', 'avatar'] as const;
export type LiveRecordTab = (typeof LIVE_RECORD_TABS)[number];

/*
 * 把 tab 取值钉在接口枚举上：除了 'all' 之外的每一项都必须是合法的 live_mode。
 * 后端将来改枚举（改名、加档）时这里会直接编译失败，而不是等到线上筛不出数据。
 */
type AssertTabsMatchLiveMode = Exclude<LiveRecordTab, 'all'> extends LiveRecordType ? true : never;
export const LIVE_RECORD_TABS_MATCH_LIVE_MODE: AssertTabsMatchLiveMode = true;

export const DEFAULT_LIVE_RECORD_TAB: LiveRecordTab = 'all';
